import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { styled } from '@mui/material/styles';
import MuiFab from '@mui/material/Fab';
import EditIcon from '@mui/icons-material/Edit';
import Box from '@mui/material/Box';

import EnhancedTable from 'components/EnhancedTable';
import ColorDot from 'components/ColorDot';

const Fab = styled(MuiFab)(({ theme }) => ({
  position: 'fixed',
  bottom: theme.spacing(2),
  right: theme.spacing(2),
  zIndex: 2,
}));

export default function SettingAppointmentPage({ tableCells, tableName }) {
  const { formatMessage } = useIntl()
  const userRights = useSelector(state => state.userRights)
  const config = useSelector(state => state.config.data)
  const data = Object.keys(config[tableName] || {}).map(i => config[tableName][i])

  const headerCells = tableCells.reduce((acc, cur) => {
    acc.push({ text: cur, align: 'left' })

    return acc
  }, []).concat({ text: 'status', align: 'right' }).map(c => { c.text = formatMessage({ id: `setAppointment.${tableName}.table.header.${c.text}` }); return c })

  const rowCells = tableCells.reduce((acc, cur) => {
    acc.push({ field: cur, align: 'left' })
    return acc
  }, []).concat({ field: 'status', align: 'right' })

  const formatData = (data) => {
    const newData = { ...data }
    newData.key = data.id
    newData.status = data.active ? '啟用' : '停用'
    if (tableName === 'treatments') {
      newData.color = <ColorDot style={{ backgroundColor: data.color }}></ColorDot>
    }
    return newData
  }

  return (
    <Box sx={{ marginTop: '20px' }}>
      {userRights.hasUserRight('setting-edit') &&
        <Link to={`/setting/appointment/${tableName}/edit`}>
          <Fab color="primary">
            <EditIcon />
          </Fab>
        </Link>
      }
      <EnhancedTable
        defaultOrder="asc"
        defaultOrderField="code"
        headerCells={headerCells}
        rowCells={rowCells}
        tableData={data.map(i => formatData(i))}
      />
    </Box>
  );

}

SettingAppointmentPage.propTypes = {
  tableCells: PropTypes.array.isRequired,
  tableName: PropTypes.string.isRequired,
};
